import {
    IState,
    IRootState,
    IStoreMock
} from './index'
import { mockActions } from './actions'
import { mockMutations } from './mutations'
import { mockGetters } from './getters'
import { mockStorage } from './storage'
import {
    mockCurrencies
} from '../entities'
import {
    mockProvider
} from '../services'

export const mockRootState = (): IRootState => ({
    version: 0,
    platform: {
        name: 'BONIFIQUE LIFE',
        full_name: 'Bonifique Life Anastasiya Halaburda',
        email: 'bonifique.life@gmail.com',
        nip: 9412503387,
        account_number: '57 1160 2202 0000 0004 7378 1243',
        account_bank: '«Millennium Bank Polska»',
        address: {
            street: 'Franciszka Klimczaka 1',
            locations: [
                'Royal Wilanów',
                'Bee Creative'
            ],
            zip: '02-797'
        },
        phones: [
            '+375 29 606 52 72',
            '+48 514 670 161'
        ],
        social: [
            {
                name: 'Facebook',
                ref: ''
            }, {
                name: 'Instagram',
                ref: ''
            }, {
                name: 'Telegram',
                ref: ''
            }, {
                name: 'WhatsApp',
                ref: ''
            }, {
                name: 'Facebook Messenger',
                ref: ''
            }, {
                name: 'Viber',
                ref: ''
            }
        ]
    },
    loading: false,
    theming: false,
    theme: undefined
})

export const mockState = (): IState => ({
    currencies: mockCurrencies(),
    currency: mockCurrencies()[0],
    ...mockRootState()
})

export const mockStore = (): IStoreMock => ({
    state: mockState(),
    actions: mockActions(),
    mutations: mockMutations(),
    getters: mockGetters(),
    replaceState: jest.fn(),
    dispatch: jest.fn(),
    commit: jest.fn(),
    subscribe: jest.fn(),
    subscribeAction: jest.fn(),
    watch: jest.fn(),
    registerModule: jest.fn(),
    unregisterModule: jest.fn(),
    hotUpdate: jest.fn(),
    hasModule: jest.fn(),
    $services: mockProvider(),
    $storage: mockStorage()
})
